import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
   emailAddress: "",
  emiratesID: "",
  firstName: "",
  fullName: "",
  isHayakUser: true,
  lastName: "",
  organizationName: "",
  password: "",
  phoneNumber: ""
  },
  reducers: {
    login(state, action) {
    
      
      state.contractType=action.payload?.contractType
      state.role = action.payload.role;
      state.email = action.payload?.member?.emailAddress != undefined ? action.payload?.member?.emailAddress : action.payload?.emailAddress
      state.isAuth = true;
      state.applicationId = action.payload?.applicationDetails?.onboardingDetails?.[0]?.id;
      state.partnerId=action.payload?.member?.partnerID

    },
    updateValue(state, action) {

      state[action.payload.key] = action.payload.value
      return
      
    },
    updateAllValues(state, action) {
      console.log("updateAllValues called");
      console.log("Initial state:", state);
      console.log("action.payload",action.payload)
    
      Object.keys(state).forEach((key) => {
        console.log("Updating key:", key);
     
          if (action.payload.hasOwnProperty(key)) {
          state[key] = action.payload[key];
        } else {
        
        
               if(key==="emailAddress")
              {
               state[key]= action.payload["emailID"]
              }
              
                if(key==="fullName")
                  {
                   state[key]= action.payload.firstName + action.payload.lastName
                  }
         
        }
        
      });
    
      console.log("Updated state:", state);
    },
    logout(state) {
      state.isAuth = false;
      state.applicationId = ""
      state.contractType=""
      localStorage.clear()
   
    },
    sessionLogin(state,action) {
      state.name = action.payload.name;
      state.contractType=action.payload?.contractType;
      state.role = action.payload.role
      state.isAuth = true;
      state.applicationId = action.payload?.applicationId
      state.partnerId = action.payload?.partnerID
      state.email = action.payload?.member?.emailAddress != undefined ? action.payload?.member?.emailAddress : action.payload?.emailAddress
    }
  },
});

export const userActions = userSlice.actions;
